// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { InterestFollowCapsuleButton } = require('client-v2/common/components/buttons')
const { registerComponentEventHandlers } = require('client-v2/common/components/utils')
// Container imports
const InterestModelRecord = require('../interest/record')

const bem = BemEntity('InterestProfileHeader')

class InterestProfileHeader extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerComponentEventHandlers(this)
  }

  renderCaption() {
    return tag('div', {
      className: bem.element('caption')
    },
      'Interest'
    )
  }

  renderFollowButton() {
    return tag(InterestFollowCapsuleButton, {
      className: bem.element('follow-button'),
      checked: this.props.interest.isFollowing,
      onClick: this.onFollowClick
    })
  }

  renderName() {
    return tag('div', {
      className: bem.element('name')
    },
      this.props.interest.name
    )
  }

  render() {
    return tag('div', {
      className: classNames(
        this.props.className,
        bem.block()
      )
    },
      this.renderCaption(),
      this.renderName(),
      this.renderFollowButton()
    )
  }
}

InterestProfileHeader.propTypes = {
  // Values
  className: PropTypes.string,
  interest: PropTypes.shape(InterestModelRecord.propTypes).isRequired
}

// Callbacks
InterestProfileHeader.eventHandlerKeys = [
  'onFollowClick'
]
InterestProfileHeader.eventHandlerKeys.forEach(key => {
  InterestProfileHeader.propTypes[key] = PropTypes.func
})

module.exports = InterestProfileHeader
